import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import { H4, H6, LI, UL } from '../../../AbstractElements'
import { categoriesChart, categoriesList } from '../../../Data/Dashboard/Ecommerce'
import ReactApexChart from 'react-apexcharts'

export default function CoreCategories() {
    return (
        <Col xxl={4} md={6} className="box-col-6">
            <Card className="categories-card">
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Core Categories "} />
                <CardBody>
                    <div className="categories-chart">
                        <div id="categories">
                            <ReactApexChart options={categoriesChart} series={categoriesChart.series} type='donut' height={410} />
                        </div>
                        <UL className='simple-list flex-row'>
                            {categoriesList.map((item) => (
                                <LI key={item.id}>
                                    <div className="d-flex">
                                        <div className="flex-shrink-0 me-2"><span className={`bg-${item.color}`} /></div>
                                        <div className="flex-grow-1">
                                            <H4>{item.percent}%</H4>
                                            <H6>{item.title}</H6>
                                        </div>
                                    </div>
                                </LI>
                            ))}
                        </UL>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
